import { Link } from "react-router-dom";
import { UserMinus } from "lucide-react";
import { Badge } from "@/components/ui/badge";

const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString() : "—");

export const RosterTable = ({ classId, students, onRemove }) => (
  <div className="overflow-x-auto rounded-3xl border border-[#E6DEC3] bg-white/60" data-testid="roster-table">
    <table className="w-full text-sm">
      <thead className="text-left text-xs uppercase tracking-widest text-stone-500">
        <tr className="border-b border-[#E6DEC3]">
          {["Student", "Grade", "Due / Missing / Done", "Lessons", "Quiz accuracy", "Mindful min", "Today", "Last lesson", ""].map((h) => <th key={h} className="px-5 py-4 font-semibold">{h}</th>)}
        </tr>
      </thead>
      <tbody>
        {students.map((s) => (
          <tr key={s.id} className="border-b border-[#E6DEC3]/60 last:border-0 hover:bg-[#F7F3EB] transition-colors" data-testid={`roster-row-${s.id}`}>
            <td className="px-5 py-4">
              <Link to={`/teacher/classes/${classId}/students/${s.id}`} className="font-medium text-[#2C4A3E] hover:text-[#C87D53]" data-testid={`roster-student-link-${s.id}`}>{s.name}</Link>
              <p className="text-xs text-stone-500">{s.email}</p>
            </td>
            <td className="px-5 py-4">{s.grade === "K" ? "K" : s.grade}</td>
            <td className="px-5 py-4 whitespace-nowrap" data-testid={`roster-work-${s.id}`}>{s.work && <><b className="text-[#1F5C99]">{s.work.due}</b> / <b className="text-[#C0392B]">{s.work.missing}</b> / <b className="text-[#2E7D4F]">{s.work.submitted}</b></>}</td>
            <td className="px-5 py-4">{s.lessons_completed}</td>
            <td className="px-5 py-4">{s.accuracy}%</td>
            <td className="px-5 py-4">{s.mindful_minutes}</td>
            <td className="px-5 py-4">
              <span className="mr-2">{s.today_minutes}m</span>
              <Badge data-testid={`roster-present-${s.id}`} className={s.present_today ? "bg-[#6B9080] hover:bg-[#6B9080]" : "bg-stone-200 text-stone-600 hover:bg-stone-200"}>
                {s.present_today ? "Present" : "Not yet"}
              </Badge>
            </td>
            <td className="px-5 py-4 text-stone-500">{fmtDate(s.last_lesson_at)}</td>
            <td className="px-5 py-4 text-right">
              <button onClick={() => onRemove(s)} data-testid={`roster-remove-${s.id}`} className="text-stone-400 hover:text-red-600 transition-colors" title="Remove from class"><UserMinus className="w-4 h-4" /></button>
            </td>
          </tr>
        ))}
        {!students.length && <tr><td colSpan={9} className="px-5 py-10 text-center text-stone-500" data-testid="roster-empty">No students yet. Share the class code to invite them.</td></tr>}
      </tbody>
    </table>
  </div>
);
